// extracted by mini-css-extract-plugin
module.exports = {"pageHome":"Home_pageHome__1syNr","vendre":"Home_vendre__bMAY1","image":"Home_image__xMuvN","c_button":"Home_c_button__2LVgY","vendu":"Home_vendu__2mONq","text":"Home_text__39p5C"};